module.exports = __webpack_public_path__ + "static/startup-6c4f9ca53df027ffd5f9cb256c5d1ab4.jpg";